import React from 'react';

import '../../design/google/tokens.css';
import '../../design/marketing/marketing.css';
import './pricing/pricing.css';

import { MarketingFooter, MarketingNav, MarketingRoot, PricingCards } from '../../design/marketing';
import Logo from './newLanding/partials/Logo';
import useMarketingPageMetadata from './pageMetadata';
import usePricingPlans from './pricing/usePricingPlans';
import { useInitialHtml } from '../../marketingRendering/InitialHtmlContext';

function PricingMarketing() {
  const initialHtml = useInitialHtml();
  useMarketingPageMetadata('pricing');
  const { label, title, description, plans, includedItems, footnote } = usePricingPlans();

  return (
    <MarketingRoot className={`pricing-page-root${initialHtml ? ' pricing-initial-html' : ''}`}>
      <MarketingNav logo={<Logo />} />
      <main>
        <PricingCards
          initialHtml={initialHtml}
          id="pricing"
          label={label}
          title={title}
          description={description}
          plans={plans}
          includedItems={includedItems}
          footnote={footnote}
        />
      </main>
      <MarketingFooter
        logo={<Logo width={100} height={56} />}
        brandCopy="AI-powered route optimization for individuals, teams, and fleets. Plan the fastest route for every trip."
        bottomText={<>&copy; 2026 Routora. All rights reserved.</>}
      />
    </MarketingRoot>
  );
}

export default PricingMarketing;
